/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { postAPI, getAPI } from "../../utils/common";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  Space,
  Button,
  Card,
  Layout,
  Table,
  Input,
  Popover,
  Divider,
} from "antd";
import { BOOKING_BY_ID, GUESTS_BOOKINGS } from "../../constants/api";
import { CURRENCY } from "../../constants/constent";
import BookingPopOver from "../booking/BookingPopOver";

function GuestsTable() {
  const { Content } = Layout;
  const navigate = useNavigate();
  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  // Booking Detail Model
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [isBookingPopOverShow, setIsBookingPopOverShow] = useState(false);
  useLayoutEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        const formattedData = data.data.map((row, index) => ({
          key: index,
          ID: index + 1,
          customer_name: row.customer_name,
          customer_email: row.customer_email,
          customer_phone: row.customer_phone,
          customer_nights: row.total_nights,
          customer_costs: `${CURRENCY}${row.total_booking_cost}`,
          bookings: (
            <Popover
              content={renderBookingList(row.booking_list)}
              title="Bookings"
              trigger="click"
              placement="bottomRight"
            >
              <Button>Bookings</Button>
            </Popover>
          ),
        }));
        setState(formattedData);
        setFilteredState(formattedData);
      } else {
        setState([]);
        setFilteredState([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredState([]);
      setLoading(false);
    };
    getAPI(GUESTS_BOOKINGS, successFn, errorFn, {});
  };

  const parseDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.toLocaleString("default", {
      month: "long",
    })} ${date.getDate()}, ${date.getFullYear()}`;
  };
  const renderBookingList = (bookings) => {
    // Check if bookings is not empty or null
    if (!bookings || bookings.length === 0) {
      return <div>No bookings available.</div>;
    }
    return (
      <div style={{ maxHeight: "200px", overflowY: "auto" }}>
        <ul>
          {bookings.map((booking, index) => (
            <li key={index}>
              <strong>Booking ID:</strong> {booking.order_id} <br />
              <strong>
                Cost:
              </strong> {`${CURRENCY}${booking.total_with_gst}`} <br />
              <strong>Date:</strong> {parseDate(booking.created_at)} <br />
              <Button onClick={() => openModel(booking.id)}>
                View Booking
              </Button>
              <Divider />
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter(
      (customer) =>
        customer.customer_name.toLowerCase().includes(value.toLowerCase()) ||
        customer.customer_email.toLowerCase().includes(value.toLowerCase()) ||
        customer.customer_phone.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredState(filtered);
  };

  const getBookingDetail = (id) => {
    const successFn = function (data) {
      if (data.status === true) {
        setSelectedBooking(data.data);
        setIsBookingPopOverShow(true);
        setLoading(false);
      } else {
        setIsBookingPopOverShow(false);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setIsBookingPopOverShow(false);
      setLoading(false);
    };
    postAPI(BOOKING_BY_ID, { id: id }, successFn, errorFn);
  };

  const openModel = (info) => {
    getBookingDetail(info);
  };

  const handleClose = () => {
    setIsBookingPopOverShow(false);
    setSelectedBooking(null);
  };
  const columns = [
    {
      title: "Sno",
      dataIndex: "ID",
      width: 50,
    },
    {
      title: "Name",
      dataIndex: "customer_name",
      width: 150,
    },
    {
      title: "Email",
      dataIndex: "customer_email",
      width: 150,
    },
    {
      title: "Phone",
      dataIndex: "customer_phone",
      width: 150,
    },
    {
      title: "Nights",
      dataIndex: "customer_nights",
      width: 150,
    },
    {
      title: "Total Value",
      dataIndex: "customer_costs",
      width: 150,
    },

    {
      title: "Bookings",
      dataIndex: "bookings",
      width: 100,
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Guests"
          extra={
            <Space>
              <Input
                placeholder="Search by Name, Email or Phone"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 300 }}
              />
              <Button onClick={() => navigate("/customer/add")}>
                Register <PlusOutlined />
              </Button>
            </Space>
          }
          bordered
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredState}
            pagination={{ pageSize: 10 }}
            scroll={{ x: 240 }}
          />
        </Card>
        {/* Detail Modal */}
        {isBookingPopOverShow && selectedBooking && (
          <BookingPopOver
            visible={isBookingPopOverShow}
            onClose={handleClose}
            booking={selectedBooking} // Pass the booking data here
          />
        )}
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default GuestsTable;
